import { CONTACT_US_URL } from 'config/constants';
import { contactUsLinkSelected } from 'lib/gaTracking/crossPageEvents';
import { Alert, Heading, Link, Text } from '@qga/roo-ui/components';

const ErrorAlertMessage = () => (
  <Alert variant="error" m={2} aria-live="assertive">
    <Heading.h5>Your guest detail changes could not be saved</Heading.h5>
    <Text>
      A technical issue occurred while your changes were being saved. Please{' '}
      <Link target="_blank" href={CONTACT_US_URL} onClick={contactUsLinkSelected}>
        contact us
      </Link>{' '}
      or try again later.
    </Text>
  </Alert>
);

export default ErrorAlertMessage;
